/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { UsersStrictHttpResponse } from '../../users-strict-http-response';
import { UsersRequestBuilder } from '../../users-request-builder';

import { UsersPresignedUploadResponseDto } from '../../models/users-presigned-upload-response-dto';
import { UsersRequestCustomTemplateUploadUrlDto } from '../../models/users-request-custom-template-upload-url-dto';

export interface TenantsControllerGenerateCustomTemplateUploadUrl$Params {

/**
 * Tenant name/slug for multi-tenancy isolation.
 */
  name: string;
      body: UsersRequestCustomTemplateUploadUrlDto
}

export function tenantsControllerGenerateCustomTemplateUploadUrl(http: HttpClient, rootUrl: string, params: TenantsControllerGenerateCustomTemplateUploadUrl$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<UsersPresignedUploadResponseDto>> {
  const rb = new UsersRequestBuilder(rootUrl, tenantsControllerGenerateCustomTemplateUploadUrl.PATH, 'post');
  if (params) {
    rb.path('name', params.name, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as UsersStrictHttpResponse<UsersPresignedUploadResponseDto>;
    })
  );
}

tenantsControllerGenerateCustomTemplateUploadUrl.PATH = '/o2-users/tenants/custom-templates/upload-url/{name}';
